<template>
    <div class="bg-wrap">
        <div class="kv">
        </div>
        <div class="content-wrap">
            <div class="title">
                {{title}}
            </div>
            <div class="content">
                    <div class="item">
                        <div class="info">
                             <span class="answer-key">
                                1、{{question}}
                             </span>
                            <span class="answer-value"  :class="v.isPlayerAnswer==1?'light':''" v-for="(v,index) in value.resolves" v-bind:key="index" >
                                {{v.resolve_order}}、{{v.resolve}}
                            </span>
                        </div>
                    </div>
                    <div class="answer">
                        <span>答案：</span>
                        <span>{{answer}}</span>
                    </div>
            </div>
        </div>
        <div class="toScreen" @click="gotoScreen(playerId,type)">
            <span>投屏</span>
        </div>
        <div class="toNext" @click="toNext">
            <span>下一题 ></span>
        </div>
    </div>
</template>

<script>
    import {getPlayerCompAnswer, toScreen} from "../../assets/js/api";

    export default {
        data() {
            return {
                title: "A卷 选择题（每题1分，共10道题，答题时间5分钟）",
                hint: "（每题1分，共10道题目，答题时间5分钟）",
                submit: "提交",
                questionId:this.$route.query.questionId,
                value: "",
                question:"",
                type:2,
                answer:"",
                playerId:this.$route.query.playerId,
            }
        },
        mounted(){
            this.initWebSocket();
            this.toGetPlayerAnswer(this.questionId,this.type)
        },
        methods:{
            async gotoScreen(playerId,type){
                const rest = await toScreen({playerId,type})
                this.$toast("----投屏成功---")
                console.log(rest)
            },
            toNext(){
                this.$router.replace({path:"hostComp"})
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonopen: function () {
                console.log("WebSocket连接成功");
            },
            websocketonerror: function (e) {
                console.log("WebSocket连接发生错误"+e.code);
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e)
                // this.toReload();//页面刷新
                this.toGetPlayerAnswer(this.questionId,this.type)
            },
            websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
            },
            async toGetPlayerAnswer(questionId,type){
                    const res = await getPlayerCompAnswer({questionId,type})
                    // console.log(res,"----player answer----")
                    this.answer=""
                    if(res.data.success){
                        this.value = res.data.data
                        this.question = this.value.question.question

                        let resolves = res.data.data.resolves
                        for(let resolve of resolves){
                            if(resolve.is_answer==1){
                                this.answer+=resolve.resolve_order+"、"
                            }
                            // console.log(resolve)
                        }
                    }
            },
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-flow: column;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .content-wrap {
        display: flex;
        flex-flow: column;
        align-items: center;
        position: relative;
    }
    .content-wrap .title {
        color: #FFF;
        font-size: 13px;
        width: 90%;
        background: #0082C5;
        border-radius: 5px;
        height: 28px;
        line-height: 28px;
    }
    .content {
        margin-top: 20px;
        height: 300px;
        width: 100%;
        overflow: auto;
        margin-bottom: 50px;
    }
    .item{
        display: flex;
        flex-flow: row;
        align-items: flex-start;
        color: #FFF;
        font-size: 13px;
        margin: 10px;
        text-align: left;
        .index{
            margin: 2px 10px 0 10px;
        }
        .info{
            display: flex;
            flex-flow: column;
            padding-bottom: 20px;
            border-bottom: 1px #b30b19 solid;
            flex-grow: 1;
        }
    }
    .info .answer-key{
        word-wrap:normal;
        word-break:break-all;
        margin-bottom: 5px;
    }
    .info .answer-value{
        margin: 2px 0;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        text-indent: 20px;
        input[type="checkbox"]{
            margin-right: 50px;
        }
    }

    .light{
        padding: 0 2px;
        background: #0082C5;
        border-radius: 5px;
    }

    .answer{
        color: #FFFFFF;
        font-size: 25px;
        text-align: left;
        margin-left: 10px;
    }


    .toNext{
        background: #0082C5;
        padding: 2px 15px;
        border-radius: 10px;

        position: absolute;
        bottom: 20px;
        right: 20px;
        color: #FFF;
        font-size: 20px;
        margin-top: 25px;
        margin-right: 10px;
        text-align: right;
    }

    .toScreen{
        background: #0082C5;
        padding: 2px 15px;
        border-radius: 10px;

        position: absolute;
        bottom: 20px;
        left: 20px;
        color: #FFF;
        font-size: 20px;
        margin-top: 25px;
        margin-right: 10px;
        text-align: right;
    }


</style>